// Kakousiji 専用の検索 URL 切替をまとめます。
export function createMasterSearchRoutingService(deps) {
    const {
        dispatch,
        setchangeurl,
        changeurl,
        KAKOUSIJI_SEARCH_MASTER_CHANGE_URL,
        kakousijiSearchMasterChangeUrlBackupRef,
        kakousijiSearchMasterRoutingActiveRef
    } = deps;

    // 共通検索 URL 一覧へ指定 route を差し込みます。
    function createSearchChangeUrlWithCommonMasterRoute(baseChangeUrl, route) {
        const source = Array.isArray(baseChangeUrl) ? [...baseChangeUrl] : [];
        const filtered = source.filter((value) =>
            typeof value !== "string" || value.toLowerCase().indexOf("common/getsearchmasterlist=") !== 0
        );
        filtered.push(route);
        return filtered;
    }

    // Kakousiji 専用の共通検索 URL を構築します。
    function createKakousijiSearchMasterChangeUrl(baseChangeUrl) {
        return createSearchChangeUrlWithCommonMasterRoute(baseChangeUrl, KAKOUSIJI_SEARCH_MASTER_CHANGE_URL);
    }

    // 退避していた changeurl を元へ戻します。
    function restoreKakousijiSearchMasterChangeUrl() {
        if (!kakousijiSearchMasterRoutingActiveRef.current) return;
        dispatch(setchangeurl(kakousijiSearchMasterChangeUrlBackupRef.current));
        kakousijiSearchMasterRoutingActiveRef.current = false;
    }

    // Kakousiji 専用の検索 URL へ一度だけ切り替えます。
    function ensureKakousijiSearchMasterChangeUrl() {
        if (kakousijiSearchMasterRoutingActiveRef.current) return;
        const nextChangeUrl = createKakousijiSearchMasterChangeUrl(changeurl);
        if (JSON.stringify(nextChangeUrl) === JSON.stringify(changeurl)) return;
        kakousijiSearchMasterChangeUrlBackupRef.current = Array.isArray(changeurl) ? [...changeurl] : [];
        dispatch(setchangeurl(nextChangeUrl));
        kakousijiSearchMasterRoutingActiveRef.current = true;
    }

    return {
        ensureKakousijiSearchMasterChangeUrl,
        restoreKakousijiSearchMasterChangeUrl
    };
}
